export const CDN_IMAGES = {
  indstocksLogo:
    'https://indcdn.indmoney.com/public/images/fe/ind_stocks_logo.svg',
  indstocksLogoDark:
    'https://indcdn.indmoney.com/public/images/fe/ind_stocks_logo_dark.svg',
  indmoneyRoundLogo:
    'https://indcdn.indmoney.com/public/images/indmoney_logo_cc.png',
  indmoneyLogo:
    'https://indcdn.indmoney.com/public/ind-marketing/indmoney-weblogo.png',
  indGlobalLogo: 'https://indcdn.indmoney.com/cdn/images/fe/indglobal-logo.png',
  twoColumnLayout:
    'https://indcdn.indmoney.com/cdn/images/fe/two_columns_icon.svg',
  mindBotLogo: 'https://indcdn.indmoney.com/cdn/images/fe/mindbot_new_logo.png',
  mindBotLogoDark:
    'https://indcdn.indmoney.com/cdn/images/fe/mindbot_new_logo_dark.png',
  mindBotNewChat:
    'https://indcdn.indmoney.com/cdn/images/fe/mindbot_new_chat.png',
  mindBotMinimize:
    'https://indcdn.indmoney.com/cdn/images/fe/mindbot_minimize_web.png',
}

export const BELL_ICON =
  'https://indcdn.indmoney.com/public/fe/images/bell_small.png'
